import { Component, Input, OnInit } from '@angular/core';
import { MapService } from 'src/app/services/map.service';


@Component({
  selector: 'app-map-styles-menu',
  templateUrl: './map-styles-menu.component.html',
  styleUrls: ['./map-styles-menu.component.scss'],
})
export class MapStylesMenuComponent  implements OnInit {

  @Input() fullScreen: boolean = false;

  public mapTypes = [
    {name  : 'Principal' , value:'outdoors-v11'},
    {name  : 'Satelital' , value:'satellite-v9' },
    {name  : 'Oscuro' , value:'dark-v11'}
  ]
  styleId: any;

  constructor(public mapService: MapService){
    
  }

  ngOnInit(): void {
    
  }

  switchLayer(style:string){
    this.mapService.switchStyle(style);
  }

}
